import * as React from 'react'

import * as LabelPrimitive from '@radix-ui/react-label'
import { type VariantProps, cva } from 'class-variance-authority'

import { classNames } from '@/utils/helpers.ts'

const labelVariants = cva(
  'text-base font-medium leading-6 peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
)

const TextLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={classNames(labelVariants(), className)}
    {...props}
  />
))

TextLabel.displayName = LabelPrimitive.Root.displayName

export { TextLabel }
